module.exports = __webpack_public_path__ + "src/assets/img/m-icon.cc4c2bb8.png";